var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404"},[_c('b-container',[_c('img',{attrs:{"id":"error","src":require("../assets/img/error404.svg"),"alt":"error404"}}),_c('h2',[_vm._v("Error 404")]),_c('p',[_vm._v("The page you are looking for is not found or is currently under development.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }